import { IAdvertChannelRepository } from '../../ports/IAdvertChannelRepository';

export class GetAdvertTelegramAccountsUseCase {
  constructor(private repo: IAdvertChannelRepository) {}
  execute(advertUUID: string) { return this.repo.getTelegramAccountsByAdvert(advertUUID); }
}
